import type { WireError } from 'shared';
import { Panel } from '../design/Panel';
import { Label } from '../design/Paper';
import { ro } from '../i18n/ro';

/** Errors are shown to the sender only, in their own language, and dismissed. */
export function ErrorToast({
  error,
  onDismiss,
}: {
  error: WireError | null;
  onDismiss: () => void;
}) {
  if (!error) return null;
  const message = ro.errors[error.code] ?? error.message;

  return (
    <div className="pointer-events-none fixed inset-x-3 bottom-3 z-50 flex justify-center">
      <button
        type="button"
        onClick={onDismiss}
        className="pointer-events-auto max-w-md text-left"
        aria-live="polite"
      >
        <Panel tone="red" press="sm" innerClassName="px-4 py-3">
          <Label className="text-[0.65rem] opacity-80">{error.code}</Label>
          <div className="mt-1 font-display text-sm uppercase">{message}</div>
        </Panel>
      </button>
    </div>
  );
}
